import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation createInvoiceMutation($input: CreateInvoiceInput!, $storeId: ID!) {
    createInvoice(input: $input) {
      invoice {
        id
      }
      storeLists {
        ...InvoiceList_storeLists @arguments(storeId: $storeId)
      }
      errors {
        key
        messages
      }
    }
  }
`;

const createInvoice = (environment, params, listsId, args = {}) => {
  const { storeId } = params;
  return commit(environment, {
    mutation,
    variables: {
      input: params,
      storeId,
    },
    configs: [
      {
        type: 'RANGE_ADD',
        parentID: listsId,
        edgeName: 'invoiceEdge',
        connectionInfo: [
          {
            key: 'InvoicetList_invoices',
            rangeBehavior: 'append',
          },
        ],
      },
    ],
    ...args,
  });
};

export default createInvoice;
